<template>
  <div class="content-wrapper" v-if="modalBehavior.showModalNpiSearch">
    <!--<save-modal-progress-bar :checkTwo="true" :currentCheck=2></save-modal-progress-bar>-->

    <ul class="list content">
      <!-- if no npi found -->
      <li v-if="npiSearchResults.length === 0">
        <h1 class="warning__title">Sorry, we couldn't find provider {{searchNpiForm.first}} {{searchNpiForm.last}}</h1>
      </li>

      <!-- render npi data -->
      <li v-else v-for="(npi, index) in paginateData" :key="index" :value="npi.id" class="list__item">
        <p>
          <span><b>{{ formatProviderName(npi) }}</b></span>
        </p>
        <p>
          <span v-if="formatProviderAddress(npi)"><font-awesome-icon :icon="['fas', 'map-marker-alt']" /> {{ formatProviderAddress(npi) }}</span>
        </p>
        <p v-if="npi.npinumber"><span>NPI: {{ npi.npinumber }}</span></p>
        <p><span v-if="npi.phone"><font-awesome-icon :icon="['fas', 'phone']"/> {{ npi.phone }}</span></p>
        <p><span v-if="npi.fax"><font-awesome-icon :icon="['fas', 'fax']"/> {{ npi.fax }}</span></p>

        <button class="btn btn-select" @click="selectNpi(npi)"
                :class="{selected: npi.npinumber === npiSelected || npi.id === npiSelected}">
          Select
        </button>
      </li>
    </ul>
    <div v-if="modalNpiSearchWarning" class="">
      <small style="color:#ff4444">* Please select a provider</small>
    </div>
    <!-- pagination -->
    <div v-if="npiSearchResults.length>0">
      <button :disabled="pageNumber === 0"
              @click="prevPage"
              class="btn btn-prev">
        Previous
      </button>

      <button v-for="index in pageCount"
              @click="toPage(index-1)"
              :key="index" class="btn-number" :class="{clicked: index === pageNumber+1}">
        {{index}}
      </button>

      <button :disabled="pageNumber >= pageCount -1"
              @click="nextPage" class="btn btn-next">
        Next
      </button>
    </div>
    <!-- footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn--cancel"
              @click="slideModalTo('main')">Go back</button>
      <button type="button" class="btn btn--success" @click="slideModalTo('procedureSearch')">Continue</button>
    </div>

  </div>
</template>

<script>
  import {searchNpi, searchCategory} from '@/api/pdfApi';

  export default {
    name: "SaveModalNpiSearch",
    props: {
      modalBehavior: Object,
      npiSearchResults: Array,
      searchNpiForm: Object,
    },
    data() {
      return {
        npiSelected: null,
        modalNpiSearchWarning: false,
        pageNumber: 0,
        size: 6,
      }
    },
    computed: {
      pageCount: function () {
        let l = this.npiSearchResults.length, s = this.size;
        return Math.ceil(l/s);
      },
      paginateData: function () {
        let start = this.pageNumber * this.size, end = start + this.size;
        return this.npiSearchResults.slice(start, end);
      }
    },
    methods: {
      slideModalTo(modal) {
        if (modal === 'main') {
          this.$emit('slideModalTo', modal);
        }
        // Document-type step skipped; continue to procedure.
        else if (modal === 'procedureSearch') {
          this.$emit('slideModalTo', modal);
        }
      },
      selectNpi(npi) {
        this.npiSelected = npi.npinumber || npi.id;
        this.$emit('selectNpi', npi);
      },
      titleCase(value) {
        const text = String(value || '').trim();
        if (!text) return '';
        return text
          .replace(/\s+/g, ' ')
          .toLowerCase()
          .replace(/\b([a-z])/g, (m) => m.toUpperCase());
      },
      formatProviderName(npi) {
        const first = this.titleCase(npi?.first_name);
        const middle = this.titleCase(npi?.middle_name);
        const last = this.titleCase(npi?.last_name);
        return [first, middle, last].filter(Boolean).join(' ');
      },
      formatProviderAddress(npi) {
        const line1 = this.titleCase(npi?.address_first_line);
        const line2 = this.titleCase(npi?.address_second_line);
        const city = this.titleCase(npi?.address_city);
        const state = String(npi?.address_state || '').trim().toUpperCase();
        return [line1, line2, city, state].filter(Boolean).join(', ');
      },

      // pagination
      nextPage() {
        this.pageNumber++;
      },
      prevPage() {
        this.pageNumber--;
      },
      toPage(pageNumber) {
        this.pageNumber = pageNumber;
      }

    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../stylesheets/modules/extraction-save-modal";
  p {
    margin-bottom: 0.5em;
  }
  .padding-5 {
    padding: 5px;
  }
  .list {
    @include flex-box();
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 0;
    font-size: 14px;
    margin-bottom: 0;
    list-style-type: none;
  }
  .list__item {
    @include flex(1, 0, 33%);
    position: relative;
    height: 100%;
  }
  .btn {
    font-size: 12px;
    margin-top: 5px;
  }
  .btn-select {
    // position: absolute;
    // bottom: 0;
  }
  .content {
    padding-top: 40px;
  }

  /* pagination */
  .btn-number {
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.75em;
  }
  .btn-prev, .btn-next {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
  .selected {
    background-color: darken(lightgray, 13%);
  }
  .clicked {
    color: #0060ff;
  }

</style>